import {
  CRM_BASE_URL,
  DAP_API,
  IAM_API,
   HCM_BASE_URL
} from "./config";

export const GET_ORG_USER = `${IAM_API}/v1/api/organization/customer-user/fetch-all-from-current-organization`;
export const GET_INDUSTRY_TYPE = `${DAP_API}/v1/api/piedap/industry`;
export const GET_DOMAIN_BY_INDUSTRY = `${DAP_API}/v1/api/piedap/domain_by_industry`;

//HCM
//personal-setup
export const CRUD_VERIFICATION_STATUS = `${HCM_BASE_URL}/v1/api/verification-status`;
export const CRUD_RECORD_STATUS = `${HCM_BASE_URL}/v1/api/personal-record-status`;
//employee-setup

export const CRUD_EMPLOYEE_CATEGORY = `${HCM_BASE_URL}/v1/api/emp-category`;
export const CRUD_EMPLOYEE_TYPE = `${HCM_BASE_URL}/v1/api/emp-type`;

export const CRUD_EMPLOYEE_STATUS = `${HCM_BASE_URL}/v1/api/emp-status`;
export const CRUD_EMPLOYEE_STATUS_REASON = `${HCM_BASE_URL}/v1/api/emp-status-reason`;

export const CRUD_EMPLOYEE_DOCUMENTS = `${HCM_BASE_URL}/v1/api/emp-document`;

export const CRUD_SEPARATION_TYPE = `${HCM_BASE_URL}/v1/api/separation-type`;
export const CRUD_SEPARATION_REASON = `${HCM_BASE_URL}/v1/api/separation-reason`;
export const CRUD_NOTICE_PERIOD = `${HCM_BASE_URL}/v1/api/notice-period`;

export const CRUD_EMPLOYMENT_TYPE = `${HCM_BASE_URL}/v1/api/employment-type`;
export const CRUD_WORKING_TIME_TYPE = `${HCM_BASE_URL}/v1/api/work-time-type`;

export const CRUD_EMPLOYEE_RECORD_STATUS = `${HCM_BASE_URL}/v1/api/emp-record-status`;

export const CRUD_LMS_COMPANY_HOLIDAYS_CONFIG = `${HCM_BASE_URL}/v1/api/company-holiday`;
export const CRUD_LMS_HOLIDAYS_CONFIG = `${HCM_BASE_URL}/v1/api/holiday`;
export const CRUD_LMS_LEAVE_TYPE_CONGIG = `${HCM_BASE_URL}/v1/api/leave-type`;
export const CRUD_LMS_ELIGIBILITY_CONFIG = `${HCM_BASE_URL}/v1/api/annual-leave-eligibility`;
export const CRUD_LMS_LEAVE_STATUS = `${HCM_BASE_URL}/v1/api/leave-status`;
export const CRUD_LMS_SITE_CONFIG = `${DAP_API}/v1/api/piedap/site_by_org`;


//my-info
export const MY_INFO_CONTACT = `${HCM_BASE_URL}/v1/api/emp-contact`;
export const MY_INFO_ADDRESS = `${HCM_BASE_URL}/v1/api/emp-address`;
export const MY_INFO_ACCOUNT = `${HCM_BASE_URL}/v1/api/emp-bank-account`;
export const MY_INFO_DEPENDENT = `${HCM_BASE_URL}/v1/api/emp-dependent`;
export const MY_INFO_NOMINEE = `${HCM_BASE_URL}/v1/api/emp-nominee`;
export const MY_INFO_PASSPORT = `${HCM_BASE_URL}/v1/api/emp-passport-detail`;
export const MY_INFO_RELATIONSHIP_CONFIG = `${HCM_BASE_URL}/v1/api/relationship-type`;
export const MY_INFO_DOCUMENT_STATUS_CONFIG = `${HCM_BASE_URL}/v1/api/document-status`;
export const MY_INFO_ADDRESS_CONFIG = `${HCM_BASE_URL}/v1/api/address-type`;
export const MY_INFO_ACCOUNT_CONFIG = `${HCM_BASE_URL}/v1/api/account-type`;


export const MY_INFO_CERTIFICATION_DETAILS = `${HCM_BASE_URL}/v1/api/certification-detail`;
export const MY_INFO_EDUCATION_DETAILS = `${HCM_BASE_URL}/v1/api/education-detail`;
export const MY_INFO_AWARDS_DETAILS = `${HCM_BASE_URL}/v1/api/emp-award`;
export const MY_INFO_DOCUMENT_DETAILS = `${HCM_BASE_URL}/v1/api/emp-myinfo-document`;
export const MY_INFO_PROFESSIONAL_DETAILS = `${HCM_BASE_URL}/v1/api/emp-professional-info`;


//Platform config

export const CRUD_PERSONAL_TITLE = `${HCM_BASE_URL}/v1/api/person-title`;
export const CRUD_PERSONAL_BLOOD_GROUP = `${HCM_BASE_URL}/v1/api/blood-group`;
export const CRUD_PERSONAL_MARITAL_STATUS = `${HCM_BASE_URL}/v1/api/marital-status`;
export const CRUD_PERSONAL_GENDER = `${HCM_BASE_URL}/v1/api/gender`;





//personal-employee
 
export const CRUD_PERSONAL_EMPLOYEE_MAIN = `${HCM_BASE_URL}/v1/api/emp-personal`;
export const CRUD_PERSONAL_EMPLOYEE_FETCH_BY_ID = `${HCM_BASE_URL}/v1/api/emp-personal/fetch-by-id`;
export const CRUD_PERSONAL_DOCUMENTS = `${HCM_BASE_URL}/v1/api/emp-onboarding-document`;
export const CRUD_EMPLOYEE_MAIN = `${HCM_BASE_URL}/v1/api/employee`;
export const CRUD_EMPLOYEE_BY_ORG_LEGAL_ID = `${HCM_BASE_URL}/v1/api/employee/current-employee`;
export const CRUD_EMPLOYEE_MAIN_FETCH_BY_ID = `${HCM_BASE_URL}/v1/api/employee/fetch-by-id`;
export const CRUD_EMPLOYMENT_MAIN = `${HCM_BASE_URL}/v1/api/employment`;
export const CRUD_EMPLOYMENT_MAIN_FETCH_BY_ID = `${HCM_BASE_URL}/v1/api/employment/fetch-by-id`;
export const HCM_PERSONAL_DOWNLOAD_DATA =  `${HCM_BASE_URL}/v1/api/employment/fetch-by-id`;
export const HCM_PERSONAL_UPLOAD_DATA =  `${HCM_BASE_URL}/v1/api/excel-parser/batch-upload-employees`;
export const HCM_EMPLOYEE_UPLOAD_DATA =  `${HCM_BASE_URL}/v1/api/excel-parser/batch-upload-employees`;
export const HCM_EMPLOYEE_TEMPLATE_DOWNLOAD_DATA =  `${HCM_BASE_URL}/v1/api/excel-parser/batch-upload-employees-template`;
export const CRUD_PERSONAL_IDENTIFICATION = `${HCM_BASE_URL}/v1/api/emp-personal-detail`;
export const CRUD_ORGANIZATION_LEGAL_ENTITY = `${DAP_API }/v1/api/piedap/org_profile_by_org`;

export const DOWNLOAD_ONBOARDING_DOCUMENTS= `${HCM_BASE_URL}/v1/api/emp-onboarding-document/download`;

export const CRUD_PERSONAL_VERIFIED_BY = `${IAM_API}/v1/api/organization/customer-user/fetch-all-from-current-organization`;

//hcm LMS

export const  LMS_LEAVE_MANAGEMENT= `${HCM_BASE_URL}/v1/api/leave-management`;
export const  LMS_LEAVE_ELIGIBILITY= `${HCM_BASE_URL}/v1/api/emp-leave-eligibility`;
export const  LMS_LEAVE_TRANSACTION= `${HCM_BASE_URL}/v1/api/leave-transaction`;